import { render, staticRenderFns } from "./TicketAlerts.vue?vue&type=template&id=4202718e&"
import script from "./TicketAlerts.vue?vue&type=script&lang=js&"
export * from "./TicketAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4202718e')) {
      api.createRecord('4202718e', component.options)
    } else {
      api.reload('4202718e', component.options)
    }
    module.hot.accept("./TicketAlerts.vue?vue&type=template&id=4202718e&", function () {
      api.rerender('4202718e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/TicketAlerts.vue"
export default component.exports